// Loyalty Module Action Types
export const SET_LOYALTY_SETTINGS = 'SET_LOYALTY_SETTINGS';
export const UPDATE_LOYALTY_SETTINGS = 'UPDATE_LOYALTY_SETTINGS';
export const SET_LOYALTY_LOADING = 'SET_LOYALTY_LOADING';
export const SET_LOYALTY_ERROR = 'SET_LOYALTY_ERROR';
export const RESET_LOYALTY_STATE = 'RESET_LOYALTY_STATE';

// Specific loyalty feature updates
export const UPDATE_LOYALTY_SYSTEM_TYPE = 'UPDATE_LOYALTY_SYSTEM_TYPE';
export const UPDATE_REWARDS_CATALOG = 'UPDATE_REWARDS_CATALOG';
export const UPDATE_TIER_CONFIGURATION = 'UPDATE_TIER_CONFIGURATION';
export const UPDATE_GAMIFICATION_SETTINGS = 'UPDATE_GAMIFICATION_SETTINGS';
